import { T } from '@tribeplatform/react-components/i18n'

import { EmailDigestAddonCard } from '../EmailDigestAddonCard.js'

export function EmailDigestRouter() {
  return <EmailDigestAddonCard />
}

export function EmailDigestBreadCrumb() {
  return <T id="Notifications.EmailDigest" defaultMessage="Email Digest" />
}
